import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-16" data-testid="footer">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-sm flex items-center justify-center">
                {/* <span className="text-white font-bold text-xl">P</span> */}
                <img 
                  src="/logo-transparent.png"
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="font-bold text-xl tracking-tight">Промтемика</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-md">
              Разработчик и производитель электронных систем дистанционного мониторинга и управления удалёнными объектами. Работаем с 2003 года.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wide mb-4">Навигация</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-slate-400 hover:text-white text-sm transition-colors">Главная</Link></li>
              <li><Link to="/products" className="text-slate-400 hover:text-white text-sm transition-colors">Продукция</Link></li>
              <li><Link to="/services" className="text-slate-400 hover:text-white text-sm transition-colors">Услуги</Link></li>
              <li><Link to="/contacts" className="text-slate-400 hover:text-white text-sm transition-colors">Контакты</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wide mb-4">Контакты</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-slate-400 text-sm">
                <Phone size={14} />
                <span>+7 (473) 416-82-49</span>
              </li>
              <li className="flex items-center gap-2 text-slate-400 text-sm">
                <Mail size={14} />
                <span>mail@promtemica.ru</span>
              </li>
              <li className="flex items-start gap-2 text-slate-400 text-sm">
                <MapPin size={14} className="mt-1 flex-shrink-0" />
                <span>Воронеж</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">© 2003-2026 ООО «Промтемика». Все права защищены.</p>
          <p className="text-slate-600 text-xs">Дистанционный мониторинг и управление</p>
        </div>
      </div>
    </footer>
  );
};